module.exports = __webpack_public_path__ + "static/media/red_pocket_loading.657f8631.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/red_pocket_loading.png
// module id = 1461
// module chunks = 0